import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { APP_CONFIG } from '../../../configs/app-config.constants';
import { InterfaceAppConfig } from '../../../configs/app-interface.config';

@Injectable({
    providedIn: 'root',
})
export class ClickbackService {
    url: any;
    domainUrl = environment.apiurl;
    constructor(
        private http: HttpClient,
        @Inject(APP_CONFIG)
        private config: InterfaceAppConfig,
    ) {}

    clickback(gyanId: any, paragraphId: any): Observable<any> {
        const url = this.domainUrl + this.config.apis.gyanSearch.clickback + '?gyanId=' + gyanId + '&paragraphId=' + paragraphId;
        return this.http.get(url);
    }
}
